import { NavLink } from 'react-router-dom';
import { FnkMark } from '@/components/branding';
import { SITE } from '@/lib/site';

export function Footer() {
  return (
    <footer className="border-t border-line bg-paper-2">
      <div className="mx-auto max-w-site px-4 py-10 sm:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <FnkMark className="h-6 w-6" />
              <span className="font-semibold">Fnk</span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink-3">
              The AI stack, the Harness and the inference underneath enterprise AI. An FNK Labs product, built in Spain.
            </p>
          </div>
          <div>
            <p className="label mb-3">Contact</p>
            <a href={`mailto:${SITE.sales}`} className="block text-sm text-ink hover:text-accent-ink">{SITE.sales}</a>
            <p className="mt-1 text-xs text-ink-3">Assessments, licences, boxes and partnerships.</p>
          </div>
          <div>
            <p className="label mb-3">First customer</p>
            <a href={SITE.dialogme} target="_blank" rel="noopener noreferrer" className="block text-sm text-ink hover:text-accent-ink">
              DialogMe — dialogme.ai
            </a>
            <p className="mt-1 text-xs text-ink-3">Runs its production workload on the Fnk stack.</p>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-3 border-t border-line pt-5 text-xs text-ink-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex gap-5">
            <NavLink to="/terms" className="hover:text-ink">Terms</NavLink>
            <NavLink to="/privacy" className="hover:text-ink">Privacy</NavLink>
            <NavLink to="/investors" className="hover:text-ink">For Investors</NavLink>
          </div>
          <p>&copy; {new Date().getFullYear()} {SITE.company}</p>
        </div>
      </div>
    </footer>
  );
}
